module.exports = __webpack_public_path__ + "static/img/a053.9dc765e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a053.jpg
// module id = rJdh
// module chunks = 0